<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M41.2404 95.1665L32.084 106.079"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M48.6587 94.8093L42.8184 101.769"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M38.3287 90.1596L32.4883 97.1192"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M71.9548 67.8698L61.8339 81.2353L65.8942 93.9044C66.0549 94.458 66.0906 95.0058 66.0013 95.5535C65.912 96.1012 65.6977 96.6013 65.3524 97.0597L64.1379 98.6612C63.4354 99.5899 62.5007 100.054 61.3278 100.054C60.1609 100.054 59.2262 99.5721 58.5237 98.6136L49.2184 85.8374L34.3942 80.3483C33.2809 79.9315 32.5665 79.1635 32.245 78.0383C31.9295 76.9131 32.12 75.8891 32.8225 74.9604L34.043 73.347C34.3823 72.9004 34.7991 72.5611 35.3051 72.3289C35.8052 72.0967 36.347 71.9836 36.9245 71.9836L50.2246 72.4539"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M60.3519 59.0884L32.2633 51.4203C30.7869 51.0154 29.8105 50.1045 29.3283 48.6757C28.846 47.2528 29.0604 45.9371 29.9772 44.7285L31.1381 43.1925C31.5608 42.6329 32.0847 42.1983 32.7218 41.8887C33.3528 41.5791 34.0256 41.4363 34.7221 41.4601L72.6578 42.8294"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.9941 76.1749C52.9941 76.1749 80.9517 9.00762 96.657 24.1414C106.736 33.8575 79.9813 54.4685 79.9813 54.4685"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M84.261 51.6108L95.8763 87.7544C96.0906 88.4212 96.1382 89.1058 96.0073 89.7965C95.8763 90.493 95.6024 91.1181 95.1797 91.6718L94.0188 93.2078C93.102 94.4164 91.8934 94.9819 90.3931 94.9045C88.8928 94.8272 87.7438 94.1365 86.958 92.8208L71.9492 67.8698"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
